<template>
  <v-card>
    <v-card-title
      class="pr-2"
      :style="{ backgroundColor: companyPrimaryColor }"
    >
      <h2 style="color:white">Voeg nieuw resultaatgebied toe</h2>
      <v-spacer></v-spacer>
      <v-btn icon dark @click="closeNewResultAreaDialog()">
        <v-icon dark color="white">close</v-icon>
      </v-btn>
    </v-card-title>

    <v-alert class="pa-4 ma-0" v-if="feedback" :value="true" type="warning">{{
      feedback
    }}</v-alert>
    <v-divider></v-divider>

    <v-card-text>
      <v-form ref="AddResultAreaForm" lazy-validation>
        <v-text-field
          label="Naam"
          v-model="newResultArea.name"
          prepend-inner-icon="assignment"
          required
          outlined
          hide-details
          :color="companyPrimaryColor"
          class="mt-4"
          :background-color="$vuetify.theme.themes[theme].menu"
        ></v-text-field>
      </v-form>
    </v-card-text>
    <v-divider></v-divider>
    <v-card-actions>
      <v-container grid-list-md fluid class="ma-0 pa-0">
        <v-layout row wrap class="ma-0 pa-0">
          <v-flex
            xs12
            md6
            class="text-left"
            v-if="
              $vuetify.breakpoint.name != 'sm' &&
                $vuetify.breakpoint.name != 'xs'
            "
          >
            <v-btn
              outlined
              depressed
              color="#8B93A6"
              @click="closeNewResultAreaDialog()"
            >
              Annuleren
            </v-btn>
          </v-flex>
          <v-flex xs12 md6 class="text-right">
            <v-btn
              dark
              rounded
              :block="
                $vuetify.breakpoint.name == 'sm' ||
                  $vuetify.breakpoint.name == 'xs'
              "
              :color="companySecondaryColor"
              @click="addResultArea()"
            >
              Resultaatgebied toevoegen
              <v-icon right dark>chevron_right</v-icon>
            </v-btn>
          </v-flex>
        </v-layout>
      </v-container>
    </v-card-actions>
  </v-card>
</template>

<script>
import db from "../../firebase/init";
import firebase from "firebase/compat/app";

export default {
  name: "add-result-area-form",
  props: {
    activeCompData: Object,
  },

  data() {
    return {
      feedback: null,
      newResultArea: {
        name: null,
        revenue: null,
      },
    };
  },

  methods: {
    closeNewResultAreaDialog() {
      this.$emit("newResultAreaDialogChange", false);
      this.newResultArea.name = null;
      this.newResultArea.revenue = null;
    },

    addResultArea() {
      if (this.newResultArea.name) {
        this.feedback = null;
        db.collection("resultAreas")
          .add({
            name: this.newResultArea.name,
            compId: this.activeCompData.id,
            deleted: {
              deleted: false,
            },
          })
          .then(() => {
            this.$emit("updateData");
            this.closeNewResultAreaDialog();
            this.$refs.AddResultAreaForm.reset();
          })
          .catch((error) => {
            console.error("Error adding result area: ", error);
          });
      } else {
        this.feedback =
          "Vul alle velden in om een resultaatgebied toe te voegen";
      }
    },
  },

  computed: {
    userRole() {
      return this.$store.state.userRole;
    },
    userCompanies() {
      return this.$store.state.userCompanies;
    },
    userCompany() {
      return this.$store.state.userCompany;
    },
    userFirstName() {
      return this.$store.state.userFirstName;
    },
    userLastName() {
      return this.$store.state.userLastName;
    },
    userRole() {
      return this.$store.state.userRole;
    },
    companyPrimaryColor() {
      return this.$store.state.companyPrimaryColor;
    },
    companySecondaryColor() {
      return this.$store.state.companySecondaryColor;
    },
    theme() {
      return this.$vuetify.theme.dark ? "dark" : "light";
    },
  },
};
</script>
